import React from 'react';
import { initialContent } from './data/content';
import './App.css';

function App() {
  const content = initialContent;

  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <nav className="nav">
          <div className="nav-container">
            <div className="nav-brand">
              <h2>{content["nav-brand-title"]}</h2>
              <span className="nav-location">{content["nav-brand-location"]}</span>
            </div>
            <div className="nav-links">
              <a href="#about">About</a>
              <a href="#capabilities">Capabilities</a>
              <a href="#industries">Industries</a>
              <a href="#quality">Quality</a>
              <a href="#contact">Contact</a>
            </div>
          </div>
        </nav>
      </header>

      <main>
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-container">
            <div className="hero-content">
              <h1>{content["hero-title"]}</h1>
              <p>{content["hero-description"]}</p>
              <div className="hero-buttons">
                <button className="btn btn-primary">{content["hero-btn-primary"]}</button>
                <button className="btn btn-secondary">{content["hero-btn-secondary"]}</button>
              </div>
            </div>
            <div className="hero-image">
              <img src="/images/aviation-space-picture-1.jpg" alt="Aerospace Manufacturing" />
            </div>
          </div>
        </section>

        {/* About Section */}
        <section id="about" className="about">
          <div className="container">
            <h2>{content["about-title"]}</h2>
            <div className="about-content">
              <p>{content["about-text-1"]}</p>
              <p>{content["about-text-2"]}</p>
            </div>
            
            {/* Stats */}
            <div className="stats">
              <div className="stat">
                <h3>{content["stat-1-number"]}</h3>
                <p>{content["stat-1-label"]}</p>
              </div>
              <div className="stat">
                <h3>{content["stat-2-number"]}</h3>
                <p>{content["stat-2-label"]}</p>
              </div>
              <div className="stat">
                <h3>{content["stat-3-number"]}</h3>
                <p>{content["stat-3-label"]}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Capabilities Section */}
        <section id="capabilities" className="capabilities">
          <div className="container">
            <h2>{content["capabilities-title"]}</h2>
            <div className="capabilities-grid">
              <div className="capability-card">
                <h3>{content["capability-1-title"]}</h3>
                <p>{content["capability-1-description"]}</p>
              </div>
              <div className="capability-card">
                <h3>{content["capability-2-title"]}</h3>
                <p>{content["capability-2-description"]}</p>
              </div>
              <div className="capability-card">
                <h3>{content["capability-3-title"]}</h3>
                <p>{content["capability-3-description"]}</p>
              </div>
              <div className="capability-card">
                <h3>{content["capability-4-title"]}</h3>
                <p>{content["capability-4-description"]}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Industries Section */}
        <section id="industries" className="industries">
          <div className="container">
            <h2>{content["industries-title"]}</h2>
            <div className="industries-grid">
              <div className="industry-card">
                <h3>{content["aerospace-title"]}</h3>
                <ul>
                  <li>{content["aerospace-item-1"]}</li>
                  <li>{content["aerospace-item-2"]}</li>
                  <li>{content["aerospace-item-3"]}</li>
                  <li>{content["aerospace-item-4"]}</li>
                </ul>
              </div>
              <div className="industry-card">
                <h3>{content["defense-title"]}</h3>
                <ul>
                  <li>{content["defense-item-1"]}</li>
                  <li>{content["defense-item-2"]}</li>
                  <li>{content["defense-item-3"]}</li>
                  <li>{content["defense-item-4"]}</li>
                </ul>
              </div>
              <div className="industry-card">
                <h3>{content["space-title"]}</h3>
                <ul>
                  <li>{content["space-item-1"]}</li>
                  <li>{content["space-item-2"]}</li>
                  <li>{content["space-item-3"]}</li>
                  <li>{content["space-item-4"]}</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Quality Section */}
        <section id="quality" className="quality">
          <div className="container">
            <h2>{content["quality-title"]}</h2>
            <div className="quality-content">
              <div className="certifications">
                <h3>{content["certifications-title"]}</h3>
                <ul>
                  <li>{content["cert-1"]}</li>
                  <li>{content["cert-2"]}</li>
                  <li>{content["cert-3"]}</li>
                  <li>{content["cert-4"]}</li>
                </ul>
              </div>
              <div className="quality-process">
                <h3>{content["quality-process-title"]}</h3>
                <p>{content["quality-process-description"]}</p>
                <ul>
                  <li>{content["quality-item-1"]}</li>
                  <li>{content["quality-item-2"]}</li>
                  <li>{content["quality-item-3"]}</li>
                  <li>{content["quality-item-4"]}</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contact" className="contact">
          <div className="container">
            <h2>{content["contact-title"]}</h2>
            <div className="contact-content">
              <div className="contact-info">
                <h3>{content["contact-info-title"]}</h3>
                <div className="contact-item">
                  <strong>{content["contact-address-label"]}</strong>
                  <p>{content["contact-address"]}</p>
                </div>
                <div className="contact-item">
                  <strong>{content["contact-phone-label"]}</strong>
                  <p>{content["contact-phone"]}</p>
                </div>
                <div className="contact-item">
                  <strong>{content["contact-email-label"]}</strong>
                  <p>{content["contact-email"]}</p>
                </div>
                <div className="contact-item">
                  <strong>{content["contact-hours-label"]}</strong>
                  <p>{content["contact-hours"]}</p>
                </div>
              </div>
              <div className="contact-form">
                <h3>{content["contact-form-title"]}</h3>
                <form>
                  <input type="text" name="company" placeholder="Company Name" required />
                  <input type="text" name="contact" placeholder="Contact Name" required />
                  <input type="email" name="email" placeholder="Email Address" required />
                  <input type="tel" name="phone" placeholder="Phone Number" />
                  <textarea name="description" placeholder="Project Description / Requirements" rows="4" required></textarea>
                  <button type="submit" className="btn btn-primary">Submit Request</button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">
              <h3>{content["footer-brand-title"]}</h3>
              <p>{content["footer-brand-description"]}</p>
            </div>
            <div className="footer-links">
              <h4>{content["footer-links-title"]}</h4>
              <a href="#about">About</a>
              <a href="#capabilities">Capabilities</a>
              <a href="#industries">Industries</a>
              <a href="#quality">Quality</a>
              <a href="#contact">Contact</a>
            </div>
            <div className="footer-contact">
              <h4>{content["footer-contact-title"]}</h4>
              <p>{content["footer-contact-location"]}</p>
              <p>{content["footer-contact-phone"]}</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>{content["footer-copyright"]}</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;